module.exports = __webpack_public_path__ + "img/L1060688.2e1ee62a.jpg";